<script>
import {
  monCompteCommandeDetailEmits,
  monCompteCommandeDetailProps,
  useMonCompteCommandeDetail
} from "./mixin";
import MesAvantages from "./commande-mes-avantages";
import GenererFacture from "@/containers/commande-generer-facture";
import CommandeNommer from "@/containers/commande-nommer";
import IconShipping from "@/components/molecules/icon-shipping";
import Icon from "@/components/atoms/icon";
import Divider from "@/components/atoms/divider";
import ButtonIcon from "@/components/molecules/button-icon";
import BadgeStatus from "@/components/molecules/badge-status";
import ProductCategory from "@/components/organisms/product-category";
import ProductCategoryItemLight from "@/components/organisms/product-category/product-category-item/light/mobile";
import Card from "@/components/molecules/card";
import OrderSummary from "@/components/organisms/order-summary";
import Popin from "@/components/molecules/popin";
import CommanderANouveau from "@/containers/commander-a-nouveau";
import Titre from "@/components/atoms/titre";
import SecuredDownloadButton from "@/containers/secured-download-button";
import PopinClickCollectTraiteurFetes from "@/components/organisms/popin-cc-traiteur-fetes";
import PopinClickCollectTraiteurPermanent from "@/components/organisms/popin-cc-traiteur-permanent";
import PopinClickAndCollect from "@/components/organisms/popin-click-collect";
import Button from "@/components/atoms/button";

export default {
  name: "CommandeDetailMobile",
  components: {
    IconShipping,
    Icon,
    Divider,
    BadgeStatus,
    Button,
    ButtonIcon,
    ProductCategory,
    ProductCategoryItemLight,
    Card,
    OrderSummary,
    MesAvantages,
    GenererFacture,
    Popin,
    CommanderANouveau,
    CommandeNommer,
    Titre,
    SecuredDownloadButton,
    PopinClickCollectTraiteurFetes,
    PopinClickCollectTraiteurPermanent,
    PopinClickAndCollect
  },
  props: {
    ...monCompteCommandeDetailProps()
  },
  data() {
    return {
      allOpened: true
    };
  },
  methods: {
    closeAll() {
      this.setOpenedAll(false);
    },
    openAll() {
      this.setOpenedAll(true);
    },
    setOpenedAll(value) {
      for (let i = 0; i < this.bySections.length; i++) {
        this.$refs[`cat-${this.bySections[i].valeur}`][0].setOpened(value);
      }
      this.allOpened = value;
    }
  },
  emits: [...monCompteCommandeDetailEmits()],
  setup(props, context) {
    const renommer = ref(null);
    const genererFacture = ref(null);

    const Button = defineAsyncComponent(() =>
      import("@/components/atoms/button")
    );

    const {
      nameChanged,
      factureGeneree,
      setPopinAjoutCarte,
      badgeVariant,
      bySections,
      nbProduits,
      nomCommande,
      showBonTicket,
      showGenererFacture,
      showImpressionFacture,
      urlFacture,
      showNumeroBonCommandePro,
      hasManyModesPaiement,
      modePaiement,
      showAvantages,
      sousTotal,
      clickAndCollectTraiteurNoelService,
      clickAndCollectTraiteurService,
      clickAndCollectService,
      isLDD,
      STATUTS_COMMANDE
    } = useMonCompteCommandeDetail(props, context, renommer, genererFacture);

    return {
      nameChanged,
      factureGeneree,
      setPopinAjoutCarte,
      badgeVariant,
      bySections,
      nbProduits,
      nomCommande,
      showBonTicket,
      showGenererFacture,
      showImpressionFacture,
      urlFacture,
      showNumeroBonCommandePro,
      hasManyModesPaiement,
      modePaiement,
      showAvantages,
      sousTotal,
      clickAndCollectTraiteurNoelService,
      clickAndCollectTraiteurService,
      clickAndCollectService,
      isLDD,
      STATUTS_COMMANDE,
      Button,
      renommer,
      genererFacture
    };
  }
};
</script>

<template>
  <div>
    <PopinClickCollectTraiteurFetes
      ref="traiteurFete"
      slide-up
      :magasin="magasin"
    />
    <PopinClickCollectTraiteurPermanent
      ref="traiteurPermanent"
      slide-up
      :magasin="magasin"
    />
    <PopinClickAndCollect
      ref="clickAndCollect"
      slide-up
      :magasin="magasin"
    />
    <PopinClickAndCollect
      ref="clickAndCollect"
      slide-up
      :magasin="magasin"
    />
    <Popin
      ref="renommer"
      aria-label="Nommer la commande"
      slide-up
    >
      <CommandeNommer
        :name="nomCommande"
        :commande="commande"
        @validate="nameChanged"
      />
    </Popin>

    <Popin
      ref="genererFacture"
      aria-label="Génerer la facture"
      page-back
    >
      <GenererFacture
        :commande="commande"
        class="u-pl-sm u-pr-sm u-pt-md u-pb-md"
        @save="factureGeneree"
      />
    </Popin>
    <Popin
      ref="commanderANouveau"
      aria-label="Commander à nouveau"
      page-back
    >
      <CommanderANouveau
        :commande="commande"
        class="u-pl-sm u-pr-sm u-pt-md u-pb-md"
        @addAllToCart="$refs.commanderANouveau.hide()"
      />
    </Popin>
    <div class="u-pl-sm u-pr-sm">
      <div class="u-flex u-flex-align-center u-flex-justify-between u-flex-wrap u-mb-xs">
        <Titre
          tag="h1"
          variant="primary"
          size="sm"
        >
          {{ commande.attributes.code }}
        </Titre>
        <template v-if="commande.attributes.code_type_commande === 'CC_TRAITEUR_NOEL' && commande.attributes.statut_code === STATUTS_COMMANDE.annulee" />
        <Button
          v-else
          link
          variant="text-light"
          class="u-ml-sm"
          href="#recap"
        >
          Voir le récapitulatif
        </Button>
      </div>
      <p
        v-if="nomCommande"
        class="u-font-17"
      >
        {{ nomCommande }}
      </p>
      <Button
        link
        variant="text-light"
        @click="$refs.renommer.show()"
      >
        <template v-if="nomCommande">
          Renommer
        </template>
        <template v-else>
          Nommer
        </template>
      </Button>

      <Titre
        tag="h2"
        size="sm"
        class="u-mb-sm u-mt-md"
      >
        Commande
      </Titre>
    </div>
    <Card class="u-p-sm u-mb-md u-border-y-border">
      <p class="u-mb-xs">
        <strong class="u-font-500">Date de la commande :</strong> <br />
        {{ dateCommande(commande.attributes.date_commande) }} à
        {{ heureCommande(commande.attributes.date_commande) }}
      </p>
      <template v-if="commande.attributes.code_type_commande == 'CC_TRAITEUR_NOEL' && commande.attributes.statut_code === STATUTS_COMMANDE.annulee" />
      <p
        v-else
        class="u-mb-xs"
      >
        <strong class="u-font-500">Total de la commande TTC :</strong> <br />
        {{ formatPrix(commande.attributes.montant_total_ttc) }} €
      </p>
      <p>
        <strong
          v-if="!hasManyModesPaiement"
          class="u-font-500"
        >Moyen de paiement utilisé :</strong>
        <strong
          v-else
          class="u-font-500"
        >Moyens de paiement utilisés :</strong>
        <br />
        {{ modePaiement }}
      </p>
      <div
        v-if="commande.attributes.detail_pro"
        class="u-mt-xs"
      >
        <p
          v-if="
            showNumeroBonCommandePro &&
              commande.attributes.detail_pro.num_bon_commande
          "
          class="u-mb-xs"
        >
          <strong class="u-font-500">Bon de commande :</strong> <br />
          {{ commande.attributes.detail_pro.num_bon_commande }}
        </p>
        <p
          v-if="commande.attributes.detail_pro.nom_client"
          class="u-mb-xs"
        >
          <strong class="u-font-500">Passée par :</strong> <br />
          {{ commande.attributes.detail_pro.nom_client }}
        </p>
        <p
          v-if="commande.attributes.detail_pro.nom_beneficiaire"
          class="u-mb-xs"
        >
          <strong class="u-font-500">Bénéficiaire :</strong> <br />
          {{ commande.attributes.detail_pro.nom_beneficiaire }}
        </p>
      </div>
    </Card>

    <Titre
      tag="h2"
      size="sm"
      class="u-mb-sm u-mt-md u-ml-sm u-mr-sm"
    >
      Client
    </Titre>
    <Card class="u-p-sm u-mb-md u-border-y-border">
      <p
        v-if="commande.attributes.detail_pro"
        class="u-mb-xs"
      >
        {{ commande.attributes.detail_pro.nom_contrat }}
      </p>
      <p
        v-for="(data, index) in commande.attributes.adresse_ticket"
        :key="`adresse-${index}`"
        :class="
          index < commande.attributes.adresse_ticket.length - 1 && 'u-mb-xs'
        "
      >
        {{ data }}
      </p>
    </Card>

    <Titre
      tag="h2"
      size="sm"
      class="u-mb-sm u-mt-md u-ml-sm u-mr-sm"
    >
      Détail de ma commande
    </Titre>
    <Card class="c-commande-detail u-border-y-border u-pl-sm u-pr-sm u-pt-md u-pb-xxs">
      <div class="u-flex u-flex-column">
        <IconShipping
          :type="commande.attributes.code_type_commande"
          class="u-mb-xs"
          variant="primary"
        >
          {{ commande.attributes.type_commande }}
        </IconShipping>
        <div
          v-if="!isLDD"
          class="u-ml-xs u-mb-sm u-flex u-flex-align-start "
        >
          <BadgeStatus
            :status="badgeVariant"
            size="sm"
            class="u-pt-xxs u-mr-xs"
          >
          </BadgeStatus>
          <div class="u-flex u-flex-column u-flex-align-start u-ml-xs">
            {{ commande.attributes.statut_long }}
            <Button
              v-if="
                commande.attributes.code_type_commande === 'CC_TRAITEUR_NOEL' &&
                  clickAndCollectTraiteurNoelService.description
              "
              link
              variant="text-light"
              class="u-mt-xxs"
              @click="$refs.traiteurFete.show()"
            >
              Voir l'emplacement du
              {{ clickAndCollectTraiteurNoelService.description }}
            </Button>
            <Button
              v-if="
                commande.attributes.code_type_commande === 'CC_TRAITEUR_PERMANENT' &&
                  clickAndCollectTraiteurService.description
              "
              link
              variant="text-light"
              class="u-mt-xxs"
              @click="$refs.traiteurPermanent.show()"
            >
              Voir l'emplacement du
              {{ clickAndCollectTraiteurService.description }}
            </Button>
            <Button
              v-if="
                commande.attributes.code_type_commande === 'CC' &&
                  clickAndCollectService.description
              "
              link
              variant="text-light"
              class="u-mt-xxs"
              @click="$refs.clickAndCollect.show()"
            >
              Voir l'emplacement du {{ clickAndCollectService.description }}
            </Button>
          </div>
        </div>
        <p class="u-inline-flex u-flex-align-center">
          <Icon
            name="location-outline"
            class="u-mr-xs u-flex-shrink-none"
          />
          <template v-if="commande.attributes.adresse_retrait">
            <template v-if="commande.attributes.description">
              {{ commande.attributes.description }} -
            </template>{{ commande.attributes.adresse_retrait.adresse }},
            {{ commande.attributes.adresse_retrait.cp }}
            {{ commande.attributes.adresse_retrait.ville }}
            <template v-if="commande.attributes.adresse_retrait.lieu">
              ({{ commande.attributes.adresse_retrait.lieu }})
            </template>
          </template>
          <template v-else>
            {{ commande.attributes.description }}
          </template>
        </p>
        <div class="u-text-center u-mt-md u-mb-md">
          <ButtonIcon
            v-if="commande.attributes.is_archive === '0'"
            icon-name="cart"
            icon-color="white"
            icon-color-hover="white"
            icon-size="sm"
            radius="full"
            size="sm"
            variant="secondary"
            :disabled="commande.attributes.nb_articles === 0"
            @click="$refs.commanderANouveau.show()"
          >
            Commander à nouveau
          </ButtonIcon>
          <br />
          <template v-if="showBonTicket">
            <SecuredDownloadButton
              :component="Button"
              link
              :secured-link="commande.attributes.label_bon_ticket.url"
              variant="text-light"
              class="u-mt-sm"
            >
              {{ commande.attributes.label_bon_ticket.statut }}
            </SecuredDownloadButton>
            <br />
          </template>
          <template v-if="showGenererFacture">
            <Button
              link
              variant="text-light"
              class="u-mt-sm"
              @click="$refs.genererFacture.show()"
            >
              Imprimer la facture
            </Button>
          </template>
          <template v-if="showImpressionFacture">
            <Button
              link
              target="_blank"
              :href="urlFacture"
              variant="text-light"
              class="u-mt-sm"
            >
              Imprimer la facture
            </Button>
          </template>
        </div>
      </div>
      <Divider />

      <div class="u-mt-md">
        <div class="u-flex u-flex-justify-between u-flex-align-center u-mb-sm">
          <p class="u-color-primary">
            {{ nbProduits }} {{ pluralize(nbProduits, "produit") }}
          </p>
          <Button
            v-if="nbProduits > 0"
            link
            variant="text-light"
            @click="setOpenedAll(!allOpened)"
          >
            <template v-if="allOpened">
              Tout replier
            </template>
            <template v-else>
              Tout déplier
            </template>
          </Button>
        </div>

        <Card
          v-for="item in bySections"
          :key="`commande-produit-${item.valeur}`"
          radius="md"
          border-color="grey-7"
          class="u-mb-md u-pt-xs u-pb-xs u-pl-sm u-pr-sm"
        >
          <ProductCategory :ref="`cat-${item.valeur}`">
            <template #title>
              {{ item.libelle }} ({{ item.articles.length }}
              {{ pluralize(item.articles.length, "produit") }})
            </template>
            <ProductCategoryItemLight
              v-for="produit in item.articles"
              :key="`${item.valeur}-${produit.id}`"
              :article="produit"
              :cart-context="trackingCodes.LABELGA.AnciennesCommandes"
              :avantages-calcules="true"
              :is-commande-ldd="
                commande.attributes.code_type_commande === 'LDD'
              "
            />
          </ProductCategory>
        </Card>
      </div>
    </Card>
    <template v-if="commande.attributes.code_type_commande === 'CC_TRAITEUR_NOEL' && commande.attributes.statut_code === STATUTS_COMMANDE.annulee" />
    <template v-else>
      <Titre
        id="recap"
        tag="h2"
        size="sm"
        class="u-mb-sm u-mt-md u-ml-sm u-mr-sm u-mt-lg"
      >
        Votre récapitulatif
      </Titre>
      <Card class="u-p-md u-border-y-border">
        <OrderSummary
          :show-detail="false"
          :nb-produits="nbProduits"
          :panier="commande.attributes"
          :total-t-t-c="commande.attributes.montant_total_ttc"
          :sous-total-t-t-c="sousTotal"
          :avantages-calcules="true"
        />
      </Card>
    </template>
    <template v-if="showAvantages">
      <Titre
        tag="h2"
        size="sm"
        class="u-mb-sm u-mt-md u-ml-sm u-mr-sm u-mt-lg"
      >
        Vos avantages
      </Titre>
      <Card class="u-p-md u-border-y-border u-mb-lg">
        <MesAvantages
          :points="commande.attributes.avantages_total_animco.points"
          :eurocora="commande.attributes.avantages_total_animco.eurocora"
          :type-fidelite="commande.attributes.type_fidelite"
          :objets="commande.attributes.avantages_total_animco.objets"
          :is-porteur-carte-cora="isPorteurCarteCora"
          :is-porteur-carte-malin="isPorteurCarteMalin"
          :is-eligible-defis="isEligibleDefis"
          @addCarte="setPopinAjoutCarte"
        />
      </Card>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.c-commande-detail__status {
  border-right: 1px solid color(grey-6);
}
</style>
